import { Voter } from "@activecollab/security";
import { MEMBER_PERMISSIONS } from "~/records/record.project";
import { isMemberWithoutPermissions, isPowerClient } from "~/utils/userHelper";

export class TaskVoter extends Voter {
  attributes = ["edit"];

  supports(attribute, subject) {
    if (!this.attributes.includes(attribute)) {
      return false;
    }
    return subject && subject.class === "Task";
  }

  voteOnAttribute(attribute, subject, user) {
    switch (attribute) {
      case "edit": {
        if (user.class === "Client") {
          return isPowerClient(user);
        }

        if (isMemberWithoutPermissions(user)) {
          const project = this.state.projects.get(`${subject.project_id}`);
          if (project && project.member_permissions === MEMBER_PERMISSIONS.STRICT && project.leader_id !== user.id) {
            return false;
          }
        }

        return true;
      }
    }

    throw new Error("This code should not be reached!");
  }
}
